import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { timeout } from "rxjs/operators";

const INDICATOR_REPORTING_CONTROLLERS = [
  "/api/equipmentmaintenance/",
  "/api/facilityindicatorassignments/",
  "/api/indicator",
  "/api/laboratorycategories/",
  "/api/laboratorylevels/",
  "/api/products/",
  "/api/surveys/",
  "/api/surveysessions/",
  "/api/thematicareas/",
  "/api/validationrules/",
];

@Injectable()
export class IndicatorReportingTimeoutInterceptor implements HttpInterceptor {
  private readonly requestTimeoutMilliseconds = 30000;
  private readonly exportTimeoutMilliseconds = 120000;

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      request.method !== "GET" ||
      !this.isIndicatorReportingRequest(request.url)
    ) {
      return next.handle(request);
    }

    const timeoutMilliseconds = request.url.toLowerCase().includes("/export")
      ? this.exportTimeoutMilliseconds
      : this.requestTimeoutMilliseconds;

    return next.handle(request).pipe(timeout(timeoutMilliseconds));
  }

  private isIndicatorReportingRequest(url: string): boolean {
    const normalizedUrl = String(url || "").toLowerCase();
    return INDICATOR_REPORTING_CONTROLLERS.some((controller) =>
      normalizedUrl.includes(controller),
    );
  }
}
